// extracted by mini-css-extract-plugin
export default {"container":"JW-z","title":"KW-z","link":"LW-z"};